import { Heading } from 'blaze-ui/Heading/Heading'
import { TextArea } from 'almanac-ui/TextInputField/Input'
import { AriaTextFieldOptions, useTextField } from '@react-aria/textfield'
import { useRef, useState } from 'react'
import Styles from './FeedbackTextField.module.scss'
import { useFocus } from '@react-aria/interactions'
import { mergeProps } from '@react-aria/utils'
import cx from 'classnames'

export const FeedbackTextField = ({
  placeholder = "We'd love any specific ideas you have...",
  label = 'Is there anything else we should know?',
  ...rest
}: AriaTextFieldOptions<'textarea'>) => {
  const ref = useRef(null)
  const {
    inputProps: { value, name, ...inputProps },
    labelProps,
  } = useTextField({ placeholder, label, ...rest }, ref)
  const [isFocused, setIsFocused] = useState(false)
  const { focusProps } = useFocus({ onFocusChange: (isFocused) => setIsFocused(isFocused) })
  return (
    <div className={cx(Styles.label, { [Styles.focused]: isFocused })}>
      <label {...labelProps}>
        <Heading level={5}>{label}</Heading>
      </label>
      <TextArea
        size="xl"
        ref={ref}
        {...mergeProps(inputProps, focusProps)}
        maxHeight={200}
        value={value as string}
        name={name as string}
        isFocused={isFocused}
      />
    </div>
  )
}
